import type { ComponentType } from "react";
import type { Locale } from "@/types";

import SovereigntyFR, {
  frontmatter as sovereigntyFRFrontmatter,
} from "./posts/sovereignty/fr.mdx";
import SovereigntyEN, {
  frontmatter as sovereigntyENFrontmatter,
} from "./posts/sovereignty/en.mdx";

export type BlogPostId = "sovereignty";

export interface PostFrontmatter {
  slug: string;
  title: string;
  dek: string;
  excerpt: string;
  date: string;
  readMinutes: number;
  authorId: string;
  tags?: string[];
}

export interface LocalePost {
  Component: ComponentType;
  frontmatter: PostFrontmatter;
}

export interface BlogPost {
  id: BlogPostId;
  fr: LocalePost;
  en: LocalePost;
  published: boolean;
}

export const BLOG_POSTS: BlogPost[] = [
  {
    id: "sovereignty",
    published: true,
    fr: { Component: SovereigntyFR, frontmatter: sovereigntyFRFrontmatter },
    en: { Component: SovereigntyEN, frontmatter: sovereigntyENFrontmatter },
  },
];

export function getBlogPostByLocaleSlug(
  slug: string,
  locale: Locale,
): BlogPost | undefined {
  return BLOG_POSTS.find((post) => post[locale].frontmatter.slug === slug);
}

export function getBlogPost(id: BlogPostId): BlogPost | undefined {
  return BLOG_POSTS.find((post) => post.id === id);
}

export interface PublishedPostEntry {
  id: BlogPostId;
  Component: ComponentType;
  frontmatter: PostFrontmatter;
}

export function getPublishedPosts(locale: Locale): PublishedPostEntry[] {
  return BLOG_POSTS.filter((post) => post.published)
    .map((post) => ({
      id: post.id,
      Component: post[locale].Component,
      frontmatter: post[locale].frontmatter,
    }))
    .sort((a, b) => b.frontmatter.date.localeCompare(a.frontmatter.date));
}
